.error {
  color: var(--comp-error-color);
  display: flex;
  flex-direction: column;
  margin: calc(5 * var(--space-big)) auto;
  opacity: 0.5;
  text-align: center;
  width: 95%;
}

.error.noMargin {
  margin: 0 auto !important;
}

.message {
  font-size: var(--font-size-4);
  line-height: var(--line-size-4);
  margin: var(--space-big) 0;
  user-select: none;
}

.icon {
  height: 42px;
  margin: var(--space-big) 0;
  margin-bottom: 0;
  user-select: none;
}

.code {
  font-size: var(--font-size-8);
  line-height: var(--line-size-8);
  margin: var(--space-medium) 0;
  margin-top: 0;
  user-select: all;
}
